export default {"src":"/_next/static/media/delete_regular.96c29577.svg","height":24,"width":24};